export const baseURL = "https://trainer.site.jadara.work/api/front" ; 
export const TITLE = "title" ;
export const LINKS = "app-links";
export const ABOUT = "about";
export const FEATURES = "features";
export const REVIEWS = "reviews";
export const PACKAGES = "packages";
export const SOCIAL = "social-media";

